import { useEffect, useState } from "react";
import cloth from "../../../../assets/webp/cloth.webp";
import CustomPopupForm from "../../../../component/customPopupModel";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { formatDateDDMMYYYY } from "../../../../utils/dateFormat";
import { RiCoupon2Line, RiCloseCircleLine } from "react-icons/ri"; // Added RiCloseCircleLine
import { serviceTypeValueToLabel } from "../../../../utils/orderPayload";
import ShopCard from "./shopcard";
import { useSelector } from "react-redux";

const PaymentSetion = ({
  storeId,
  selectedService,
  orderItems,
  totalValue,
  paymentBreakDown,
  handleApplyCoupon,
  laundry,
  selectedAddOns
}) => {
  const discount = (laundry?.originalPrice || 0) - (laundry?.totalPrice || 0);
  const [open, setOpen] = useState(false);
  const [campaignData, setCampaignData] = useState([]);
  const showSnackbar = useSnackbar();
  const { payloadAddress } = useSelector((state) => state.customer);

  useEffect(() => {
    if (storeId) {
      fetchCampaigns();
    }
  }, [storeId, totalValue]);

  const fetchCampaigns = () => {
    const serviceType = serviceTypeValueToLabel(selectedService);

    axiosInstance
      .get(`/customer/store/applicable`, {
        params: {
          storeId,
          serviceType: serviceType,
          totalAmount: parseFloat(laundry?.totalPrice || 0),
          region: payloadAddress?.zipcode || ""
        },
      })
      .then((res) => {
        const campaigns = res?.data || [];
        const formatted = campaigns.map((item) => ({
          id: item.id,
          name: item.name,
          code: item.code,
          discountText:
            item.promotionType === "flat_percent"
              ? `Save ${item.xValue}%`
              : item.promotionType === "flat_dollar"
                ? `Save $${item.xValue}`
                : "",
          details: `Minimum order count: ${item.minimum_order_count}`,
          expires: formatDateDDMMYYYY(item.endDate),
          maxSavings: item.zValue
            ? `$${item.zValue}`
            : item.xValue
              ? `$${item.xValue}`
              : "",
        }));
        setCampaignData(formatted);
      })
      .catch((error) => {
        showSnackbar("Something went wrong!", "error");
      });
  };

  return (
    <div className="w-full h-full p-6 border border-[#D8DAE5] rounded-2xl bg-white shadow-sm">
      <div className="block lg:hidden mb-2">
        <ShopCard laundry={laundry} />
      </div>

      <div className="mb-4">
        <h2 className="text-lg font-bold text-[#063853]">{selectedService}</h2>
      </div>

      {orderItems?.map((service, index) => (
        <div key={index}>
          <div className=" mb-1">
            <div className="flex items-center gap-3">
              <img src={cloth} alt="Cloth icon" className="w-6 h-6 mt-0.5" />
              <div className="flex justify-between w-full">
                <div>
                  <div className="text-sm sm:text-base font-[500] text-[#2F2F2F]">
                    {service.item_name}
                  </div>
                  <div className=" mb-2 text-xs font-[500] text-[#666666] space-y-0.5">
                    {selectedService === "Wash & Fold" ? (
                      <div>{service.quantity} Lbs</div>
                    ) : (
                      <div>{service.quantity} Qty</div>
                    )}
                  </div>
                </div>
                <div className="text-sm sm:text-base font-[600] text-[#2F2F2F]">
                  $ {service.price.toFixed(2)}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              {selectedService === "Tailoring" &&
                service?.tailoring_types?.map((desc, i) => (
                  <span
                    key={i}
                    className="px-2 py-[1px] bg-blue-100 text-[#1B7EB8] text-[10px] font-[500] rounded-full shadow-sm"
                  >
                    {desc?.name}
                  </span>
                ))}
            </div>
          </div>
          {index < orderItems.length - 1 && (
            <div className="border-t border-[#D8DAE5] my-3" />
          )}
        </div>
      ))}

      {selectedAddOns?.length > 0 && (
        <div className="bg-[#e7f2f8] rounded-lg p-4 mt-2">
          <div className="text-sm sm:text-base font-[600] text-[#2F2F2F] mb-[6px]">
            Selected Add Ons
          </div>
          {selectedAddOns.map((addOn, index) => {
            const priceNum = parseFloat(addOn?.price?.replace("$", "")) || 0;
            const total = priceNum * addOn?.qty;
            return (
              <div
                key={index}
                className="flex justify-between text-xs sm:text-sm font-[500] text-[#2F2F2F] mb-1"
              >
                <div className="flex gap-2">
                  <div>{addOn?.name}</div>
                  <div>x{addOn?.qty}</div>
                </div>
                <div>${total.toFixed(2)}</div>
              </div>
            );
          })}
        </div>
      )}

      {/* Divider */}
      <div className="border-t border-black my-3"></div>

      {/* Amounts */}
      <div className="text-[#2F2F2F] text-sm sm:text-base">
        {discount > 0 && (
          <div className="flex justify-between mb-2">
            <span className="font-[500]">Discount</span>
            <span className="font-[600] text-green-700">
              -${discount?.toFixed(2)}
            </span>
          </div>
        )}
        <div className="flex justify-between mb-2">
          <span className="font-[500]">Order Estimate</span>
          <span className="font-[600]">${totalValue}</span>
        </div>

        <div className="flex justify-between mb-2">
          <span className="font-[500]">Platform Amount</span>
          <span className="font-[600]">${paymentBreakDown.platformFee}</span>
        </div>

        <div className="flex justify-between mb-2">
          <span className="font-[500]">Tax</span>
          <span className="font-[600]">${paymentBreakDown.tax}</span>
        </div>

        <div className="flex justify-between mb-2">
          <span className="font-[500]">Delivery Partner Amount</span>
          <span className="font-[600]">${paymentBreakDown.deliveryCharge}</span>
        </div>

        

        {/* Updated Offer Applied Section with Remove Button */}
        {paymentBreakDown.discount > 0 && (
          <div className="flex justify-between items-center mb-2">
            <div className="flex items-center gap-1.5">
              <span className="font-[500]">Offer Applied</span>
              <RiCloseCircleLine
                className="text-red-500 cursor-pointer hover:text-red-700 transition"
                size={18}
                title="Remove Coupon"
                onClick={() => handleApplyCoupon("")} // Sends empty data to remove coupon
              />
            </div>
            <span className="font-[600] text-green-700">
              -${paymentBreakDown.discount}
            </span>
          </div>
        )}
      </div>

      {/* Coupon Code Selection */}
      <div className="flex items-center justify-between my-4">
        <div className="flex items-center text-[#2F2F2F] font-[500]">
          <RiCoupon2Line className="text-sm sm:text-base md:text-lg mr-2" />
          <span className="text-sm sm:text-base">Apply Coupon</span>
        </div>
        <div
          onClick={() => setOpen(true)}
          className="cursor-pointer text-sm sm:text-base font-[600] text-green-700 hover:text-green-800"
        >
          {paymentBreakDown.discount > 0 ? "Change Coupon" : "Apply Coupon"}
        </div>
      </div>

      <div className="border-t border-gray-200 my-3"></div>

      {/* Total Estimate */}
      <div className="flex justify-between text-sm sm:text-base md:text-lg text-[#2F2F2F]">
        <span className="font-[600]">Estimate Amount:</span>
        <span className="font-[600]">$ {paymentBreakDown.finalPayable}</span>
      </div>

      <CustomPopupForm
        isOpen={open}
        handleClose={() => setOpen(false)}
        dialogType="discount"
        onSubmit={(code) => {
          setOpen(false);
          handleApplyCoupon(code);
        }}
        dialogDetails={{ storeId: storeId, campaignData: campaignData }}
      />
    </div>
  );
};

export default PaymentSetion;
